module.exports = __webpack_public_path__ + "static/p04_cencerroBoton-8401862f18bc73a371324f4475e96783.png";